import { React, useState } from "react";
import "../App.css";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useUserAuth } from "../auth";

const ForgotPasswordPage = () => {
	const { forgotPassword } = useUserAuth();
	const [email, setEmail] = useState("");

	const handleForgotPassword = async (e) => {
		e.preventDefault();
		await forgotPassword(email);
	};

	return (
		<motion.section initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ ease: "linear", duration: 0.08 }} style={{ backgroundImage: `url('https://firebasestorage.googleapis.com/v0/b/space-73.appspot.com/o/Reset-password-pana.svg?alt=media')`, backgroundSize: "600px", backgroundPosition: "left" }}>
			<div id="loginForm" className="loginForm">
				<div className="title-div">
					<h3>Forgot Password</h3>
				</div>
				<hr />
				<form onSubmit={handleForgotPassword} className="form">
					<div className="form-groups">
						<div className="form-group">
							<input type="email" value={email} onChange={(e) => setEmail(e.target.value)} id="login_email" name="login_email" placeholder="Enter registered Email ID" autoComplete="off" required />
							<label>Email</label>
						</div>
					</div>
					<div className="buttons">
						<button type="submit" className="btn">
							Submit
						</button>
					</div>
				</form>
				<div className="options">
					<p>Already have an account?</p>
					<Link className="optionlink" to="/login">
						Login
					</Link>
				</div>
			</div>
		</motion.section>
	);
};

export default ForgotPasswordPage;
